module.exports = __webpack_public_path__ + "static/media/collaboration.be7ca3bd.svg";